import { useDispatch, useSelector } from 'react-redux'
import { selectTranslations } from '../../../services/i18n/i18nSlice'
import { useEffect, useState } from 'react';

import arrow_left from '../../../assets/images/nav_icons/arrow-left.svg'

import upload_img from '../../../assets/images/upload_white.svg'
import downalod_img from '../../../assets/images/download.svg'
import plus_img from '../../../assets/images/plus_white.svg'
import plus_blue from '../../../assets/images/plus.svg'
import excel_img from '../../../assets/images/questions/excel.svg'
import excel_template from '../../../assets/questions_trainings.xlsx'
import QuestionsUploader from '../../../components/_questions/QuestionsUploader';
import QuestionEditor from '../../../components/_questions/QuestionEditor';
import { setLoading } from '../../../services/global/globalSlice';
import { toast } from 'react-toastify';
import { fetchDownloadQuestions } from '../TrainingApi';
import ConfirmModal from '../../../components/_modals/ConfirmModal';
import EditableInput from '../../../components/_form/EditableInput';
import SubjectTopicSelect from '../../../components/_questions/SubjectTopicSelect';
import { fetchSubjects, fetchTopics } from '../../QuestionBankScreen/QuestionBankApi';

export default function TrainingQuestion (props) {

    const t = useSelector(selectTranslations)
    const dispatch = useDispatch()

    const [questionsSelection, setQuestionsSelection] = useState([])
    const [showUploadModal, setShopUploadModal] = useState(false)
    const [resetUpload, setResetUpload] = useState(false)
    const [forceUpload, setForceUpload] = useState(false)
    const [confirmModal, setConfirmModal] = useState({
        title: "",
        text: "",
        onClose: null,
        onConfirm: null,
        confirmCta: "",
        closeCta: ""
    })

    const [showQuestionEditor, setShowQuestionEditor] = useState(false)
    const [selectedQuestion, setSelectedQuestion] = useState(null)

    const [subjects, setSubjects] = useState([])
    const [topics, setTopics] = useState([])

    useEffect(()=>{
        fetchSubjects().then(r=>{ if(r.success) setSubjects(r.data || []) })
        fetchTopics().then(r=>{ if(r.success) setTopics(r.data || []) })
    },[])

    const mode = props.trainingData?.topic_ids !== undefined ? 'topics' : 'questions'

    const switchMode = (newMode) => {
        const _trainingData = structuredClone(props.trainingData)
        if(newMode === 'topics'){
            delete _trainingData.questions
            _trainingData.topic_ids = []
        } else {
            delete _trainingData.topic_ids
            _trainingData.questions = []
        }
        props.onTrainingDataChange(_trainingData)
    }

    const handleSwitchMode = (newMode, force = false) => {
        const hasContentToDiscard = newMode === 'topics'
            ? props.trainingData?.questions?.length > 0
            : props.trainingData?.topic_ids?.length > 0
        if(!force && hasContentToDiscard){
            setConfirmModal({
                ...confirmModal,
                show: true,
                title: t.question_bank.switch_mode_confirm_title,
                text: t.question_bank.switch_mode_confirm_text,
                onClose: ()=>closeConfirmModal(),
                onConfirm: ()=>{ switchMode(newMode); closeConfirmModal() },
                confirmCta: t.modals.confirm,
                closeCta: t.modals.abort,
            })
        } else {
            switchMode(newMode)
        }
    }

    const handleTopicIdsChange = (newTopicIds) => {
        props.onTrainingDataChange({
            ...props.trainingData,
            topic_ids: newTopicIds
        })
    }

    const handleRenderQuestions = ( ) => {
        setShopUploadModal(false)
        setResetUpload(false)
        props.reloadData()
    }

    const handleQuestionDataChange = (data) => {
        let _questions = structuredClone(props.trainingData?.questions)
        _questions[selectedQuestion] = data
        props.onTrainingDataChange({
            ...props.trainingData,
            questions: _questions
        })
    }

    const addQuestion = (module_id) =>{
        let _questions = structuredClone(props.trainingData?.questions || [])
        _questions.push({
            question_type: "base",
            text: "",
            answers: [],
            isNew:true
        })
        const question_id = _questions?.length - 1
        props.onTrainingDataChange({
            ...props.trainingData,
            questions: _questions
        })
        openQuestion(question_id)
    }

    const openQuestion = (question_id, question) => {
        setSelectedQuestion(question_id)
        setShowQuestionEditor(true)
    }

    const handleCloseQuestion = () => {
        setSelectedQuestion(null)
        setShowQuestionEditor(false)
    }

    const downloadQuestions = async () => {
        dispatch(setLoading(true))
        const response = await fetchDownloadQuestions(props.trainingData.folder_id);
        if (response.success) {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `questions_training_${props.trainingData.folder_id}_${new Date().toLocaleDateString("it-IT")}.xlsx`);
            document.body.appendChild(link);
            link.click();
            dispatch(setLoading(false))
        } else {
            toast.error(t.question.error_while_downloading)
            dispatch(setLoading(false))
        }
    }

    const closeConfirmModal = () =>{
        setConfirmModal({
            ...confirmModal,
            show:false
        })
    }

    const handleRemoveQuestion = (_,force = false) => {
        if(!force){
            setConfirmModal({
                ...confirmModal,
                show:true,
                title: t.question.delete_title,
                text: t.question.delete_text,
                onClose: ()=>closeConfirmModal(),
                onConfirm: ()=>handleRemoveQuestion(true,true),
                confirmCta: t.question.delete_cta,
                closeCta: t.modals.no_exit,
            })
        } else {
            let _questions = structuredClone(props.trainingData?.questions || [])
            if (selectedQuestion > -1) { 
                _questions.splice(selectedQuestion, 1); 
            }
            closeConfirmModal()
            setShowQuestionEditor(false)
            setSelectedQuestion(null)
            props.onTrainingDataChange({
                ...props.trainingData,
                questions: _questions
            })
        }
    }

    const handleSaveQuestion = () => {
        const _questions = structuredClone(props.trainingData?.questions)
        const _question = _questions[selectedQuestion]
        if(!_question.text){
            toast.error(t.question.required_text)
            return;
        }
        if(_question.question_type !== "block"){
            const min_answers = _question.question_type === "fill" ? 1 : 2
            if(_question.answers?.length < min_answers){
                toast.error(_question.question_type === "fill" ? t.question.min_answers_fill : t.question.min_answers)
                return;
            }
            const correct_answers = _question.answers.filter(a=>a.is_correct_answer === true)
            if(_question.question_type === "base" && correct_answers.length > 1){
                toast.error(t.question.only_one_correct)
                return;
            }
            if(_question.question_type !== "survey" && correct_answers.length === 0){
                toast.error(t.question.at_least_one_correct)
                return;
            }   
        } else {
            if(_question.blocks?.length < 1){
                toast.error(t.question.min_block)
                return;
            }
            let block = false
            _question.blocks?.forEach(block => {
                if(!block.text){
                    toast.error(t.question.required_text_block)
                    block = true
                }
                const correct_answers = block.answers.filter(a=>a.is_correct_answer === true)
                if(correct_answers.length > 1){
                    toast.error(t.question.only_one_correct)
                    block = true
                }
            });
            if(block)
                return;
        }
        setSelectedQuestion(null)
        setShowQuestionEditor(false)
    }

    return (
        <>
            <div className='mode_toggle'>
                <button className={mode === 'topics' ? 'secondary' : ''} onClick={()=>handleSwitchMode('questions')}>{t.question_bank.mode_questions}</button>
                <button className={mode === 'topics' ? '' : 'secondary'} onClick={()=>handleSwitchMode('topics')}>{t.question_bank.mode_topics}</button>
            </div>
            { mode === 'topics' ?
                <SubjectTopicSelect subjects={subjects} topics={topics} value={props.trainingData?.topic_ids} onChange={handleTopicIdsChange} />
            : <>
            { (!props.trainingData?.questions || props.trainingData?.questions?.length === 0 || resetUpload) && !forceUpload ?
                <>
                    <div className="info_card">
                        <h2>{t.question.question_adding}</h2>
                        <div className='d-flex mt-3'>
                            <button onClick={()=>setShopUploadModal(true)}>
                                {t.question.excel_import}
                                <img src={upload_img} className='ms-1' alt=''/>
                            </button>
                            <button className='ms-2' onClick={()=>{setResetUpload(false); setForceUpload(true)}}>
                                {t.question.create_question}
                                <img src={plus_img} className='ms-1' alt=''/>
                            </button>
                        </div>
                    </div> 
                    
                    <div className="info_card">
                        <h2>{t.question.need_help}</h2>
                        <p>{t.question.need_help_text}</p>
                        <div className='d-flex justify-content-between'>
                            <div className="info_card">
                                <h3><img src={excel_img} className='me-1'/>{t.question.template_excel}</h3>
                                <p>{t.question.template_excel_text}</p>
                                <a href={excel_template} download>
                                <button className='secondary'>
                                    {t.question.download_template}
                                    <img src={downalod_img} className='ms-1' alt=''/>
                                </button>
                                </a>
                            </div>  
                        </div>
                    </div> 
                    <QuestionsUploader show={showUploadModal} onClose={()=>setShopUploadModal(false)} endpoint={`/admin/add_new_training_questions_from_excel?folder_id=${props.trainingData.folder_id}`} onUploadComplete={handleRenderQuestions} />
                </>
            : <div className='d-flex justify-content-between align-items-center'> 
                <a href='#' onClick={()=>{setResetUpload(true); setForceUpload(false)}}>
                    <img src={arrow_left} />
                    {t.question.back_to_upload}
                </a>
                <a href='#' onClick={downloadQuestions}>
                    {t.question.download_questions}
                </a>
            </div> }

            { !resetUpload ?
            <div>
                
                <div className='questions_module mt-2'>
                    <div className='d-flex justify-content-end mb-3'>   
                        <a href={`#`} onClick={addQuestion}>
                            <u>{t.question.add_question}</u>
                            <img src={plus_blue} className='ms-1' alt=''/>
                        </a>
                    </div>
                    {props.trainingData?.questions && props.trainingData?.questions?.length > 0 ?
                        <div className='module_questions'>
                        {props.trainingData?.questions?.map((question,i_q)=>{
                            return (
                                <div key={i_q} className='module_question d-flex align-items-center pointer' onDoubleClick={()=>openQuestion(i_q,question)}>
                                    <input type='checkbox' className='input-check'/>
                                    <span className='ms-2 mb-0'><strong>{t.question.question} {i_q+1}</strong></span>
                                    <p className='ms-2 mb-0'>{question.text}</p>
                                </div>
                            )
                        })}
                        </div>
                    : ""}
                </div>
                <QuestionEditor 
                    show={showQuestionEditor} 
                    closeQuestion={handleCloseQuestion}
                    handleDataChange={handleQuestionDataChange}
                    updateQuestions={handleSaveQuestion}
                    removeQuestion={handleRemoveQuestion}
                    questionData={selectedQuestion !== null ? props.trainingData?.questions[selectedQuestion] : null}
                />
            </div> : null }
            </>
            }
            <ConfirmModal props={confirmModal}/>
        </>

    )
}